import * as React from 'react'
import * as styles from './tile.layout.styl'
import cx from 'classnames'

interface TileProps {
  id?: string
  title?: string
  className?: string
  onClick?: () => void
}

const Tile: React.FC<TileProps> = ({
  title,
  id,
  className,
  onClick,
  children
}: React.PropsWithChildren<TileProps>) => {
  function handleClick() {
    if (typeof onClick === 'function') {
      onClick()
    }
  }
  return (
    <div id={id} onClick={handleClick} className={cx(className, styles.tile)}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {children}
    </div>
  )
}

export default Tile
